import { setRange } from './helpers';

export const setArea = setRange('total_area');
